import React, { useState } from 'react';
import { ButtonGroup, Button } from 'react-bootstrap';
import { regions } from '../../data/regions';

export const SelectAllRegions = (props) => {
  function onClickButton(e) {
    const { name } = e.target;
    let arr = [];
    if (name === 'all') {
      arr = regions;
    } else if (name === 'euro') {
      arr = ['de', 'fr', 'es', 'it', 'nl'];
    } else if (name === 'pl') {
      arr = ['pl'];
    } else if (name === 'gb') {
      arr = ['gb'];
    } else if (name === 'se') {
      arr = ['se'];
    } else if (name === 'us') {
      arr = ['us'];
    }
    props.setSelectedRegions(arr);
  }

  return (
    <>
      <ButtonGroup>
        <Button
          name='all'
          onClick={(e) => {
            onClickButton(e);
          }}
          variant='secondary'
        >
          Select All
        </Button>
        <Button
          name='gb'
          onClick={(e) => {
            onClickButton(e);
          }}
          variant='secondary'
        >
          Select GB
        </Button>

        <Button
          name='euro'
          onClick={(e) => {
            onClickButton(e);
          }}
          variant='secondary'
        >
          Select Euros
        </Button>
        <Button
          name='pl'
          onClick={(e) => {
            onClickButton(e);
          }}
          variant='secondary'
        >
          Select PL
        </Button>
        <Button
          name='se'
          onClick={(e) => {
            onClickButton(e);
          }}
          variant='secondary'
        >
          Select SE
        </Button>
        <Button
          name='us'
          onClick={(e) => {
            onClickButton(e);
          }}
          variant='secondary'
        >
          Select US
        </Button>
        <Button
          name='none'
          onClick={(e) => {
            onClickButton(e);
          }}
          variant='secondary'
        >
          Select None
        </Button>
      </ButtonGroup>
    </>
  );
};
